;(function ($) {

    const QuizButtons = {

        init() {
            $(document).ready(() => {
                this.wrapButtons();
            });
        },

        wrapButtons() {
            const questions = document.querySelectorAll('.wpProQuiz_listItem');

            if (!questions.length) {
                return;
            }

            questions.forEach((question) => {
                const buttons = question.querySelectorAll('input[type="button"]:not([name="tip"])');

                if (!buttons.length) {
                    return;
                }

                const wrapper = document.createElement('div');
                wrapper.classList.add('quiz-buttons-wrapper');

                const firstButton = buttons[0];
                const parent = firstButton.parentNode;

                if (!parent) {
                    return;
                }

                parent.insertBefore(wrapper, firstButton);

                buttons.forEach((button) => {
                    wrapper.appendChild(button);
                });
            });
        },

    };

    if (document.querySelector('.wpProQuiz_listItem')) {
        QuizButtons.init();
    }

}(jQuery));